// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerSimilar {
  display: flex;
  gap: 40px;
  padding-top: 20px;
  flex-direction: row;
  flex-wrap: wrap;
}

.containerInput {
  display: flex;
  flex-direction: column;
  padding-top: 35px;
  left: 8px !important;
}

.containerFormBasic {
  display: flex;
  flex-direction: column;
  padding: 35px 0 0 35px;
}

.StarContainer {
  position: relative;
}

.iconStar {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 10;
  width: 25px;
}

@media (min-width: 100px) and (max-width: 700px) {
  .containerSimilar {
    display: flex;
    /* flex-direction: column; */
    gap: 30px;
    padding-top: 30px;
  }

  .iconStar {
    position: absolute;
    left: 280px;
    top: 15px;
    z-index: 10;
    width: 25px;
  }
}

.searchInputs {
  display: flex;
  align-items: center;
  padding: 0 32px;
  width: 500px;
  height: 75px;
  border-radius: 5px;
  background-color: white;

  gap: 24px;
}

.searchInputs input {
  border: 0;
  outline: 0;
  background: none;
  font-size: 22px;
  width: 100%;
}

.dataResult {
  border-radius: 5px;
  background: #f1f1f1;
  width: 318px;
  max-height: 300px;
  overflow: hidden;
  overflow-y: auto;
  position: absolute;
  z-index: 999;
}

.dataResult::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.dataResult::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.dataResult::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.dataResult::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.dataItem {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
}

.dataItem:hover {
  background-color: #e9e9e9;
}

.buttonHover:hover {
  background-color: #00629a;
}

.buttonHover {
  background-color: #007bc0;
}

.css-8rwjl-MuiInputBase-root-MuiFilledInput-root::after {
  border-bottom: 1px solid #000 !important;
}

.containerQuestions
  .css-1bvfklc-MuiInputBase-root-MuiFilledInput-root.Mui-focused {
  background-color: transparent !important;
}

.containerQuestion h4 {
  display: none;
}

.containerQuestions .css-1bvfklc-MuiInputBase-root-MuiFilledInput-root::after {
  border-bottom: 0px !important;
}

.containerQuestions .css-1bvfklc-MuiInputBase-root-MuiFilledInput-root::before {
  border-bottom: 0px !important;
}

.css-8rwjl-MuiInputBase-root-MuiFilledInput-root {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
}

.css-10048ta-MuiInputBase-root-MuiFilledInput-root::after,
.css-pq2155-MuiInputBase-root-MuiFilledInput-root::after,
.css-hl58tn-MuiInputBase-root-MuiFilledInput-root::after {
  border-bottom: 1px solid #000 !important;
}

.css-hl58tn-MuiInputBase-root-MuiFilledInput-root.Mui-focused {
  width: 314px !important;
}

.containerQuestion .MuiInputBase-root {
  padding: 35px 12px 8px !important;
}

.css-dfpqc0 {
  position: absolute !important;
}

.hover-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.truncated {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  display: inline-block;
}

.hover-popup {
  position: absolute;
  top: 120%;
  left: 0;
  background: white;
  color: black;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  z-index: 999;
  display: none;
}

.hover-container:hover .hover-popup {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/formBasicInfo/formBasicInfo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,4BAA4B;IAC5B,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;;EAEvB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".containerSimilar {\n  display: flex;\n  gap: 40px;\n  padding-top: 20px;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.containerInput {\n  display: flex;\n  flex-direction: column;\n  padding-top: 35px;\n  left: 8px !important;\n}\n\n.containerFormBasic {\n  display: flex;\n  flex-direction: column;\n  padding: 35px 0 0 35px;\n}\n\n.StarContainer {\n  position: relative;\n}\n\n.iconStar {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  cursor: pointer;\n  z-index: 10;\n  width: 25px;\n}\n\n@media (min-width: 100px) and (max-width: 700px) {\n  .containerSimilar {\n    display: flex;\n    /* flex-direction: column; */\n    gap: 30px;\n    padding-top: 30px;\n  }\n\n  .iconStar {\n    position: absolute;\n    left: 280px;\n    top: 15px;\n    z-index: 10;\n    width: 25px;\n  }\n}\n\n.searchInputs {\n  display: flex;\n  align-items: center;\n  padding: 0 32px;\n  width: 500px;\n  height: 75px;\n  border-radius: 5px;\n  background-color: white;\n\n  gap: 24px;\n}\n\n.searchInputs input {\n  border: 0;\n  outline: 0;\n  background: none;\n  font-size: 22px;\n  width: 100%;\n}\n\n.dataResult {\n  border-radius: 5px;\n  background: #f1f1f1;\n  width: 318px;\n  max-height: 300px;\n  overflow: hidden;\n  overflow-y: auto;\n  position: absolute;\n  z-index: 999;\n}\n\n.dataResult::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n.dataResult::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.dataResult::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.dataResult::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.dataItem {\n  padding: 5px 12px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n}\n\n.dataItem:hover {\n  background-color: #e9e9e9;\n}\n\n.buttonHover:hover {\n  background-color: #00629a;\n}\n\n.buttonHover {\n  background-color: #007bc0;\n}\n\n.css-8rwjl-MuiInputBase-root-MuiFilledInput-root::after {\n  border-bottom: 1px solid #000 !important;\n}\n\n.containerQuestions\n  .css-1bvfklc-MuiInputBase-root-MuiFilledInput-root.Mui-focused {\n  background-color: transparent !important;\n}\n\n.containerQuestion h4 {\n  display: none;\n}\n\n.containerQuestions .css-1bvfklc-MuiInputBase-root-MuiFilledInput-root::after {\n  border-bottom: 0px !important;\n}\n\n.containerQuestions .css-1bvfklc-MuiInputBase-root-MuiFilledInput-root::before {\n  border-bottom: 0px !important;\n}\n\n.css-8rwjl-MuiInputBase-root-MuiFilledInput-root {\n  border-top-left-radius: 0px !important;\n  border-top-right-radius: 0px !important;\n}\n\n.css-10048ta-MuiInputBase-root-MuiFilledInput-root::after,\n.css-pq2155-MuiInputBase-root-MuiFilledInput-root::after,\n.css-hl58tn-MuiInputBase-root-MuiFilledInput-root::after {\n  border-bottom: 1px solid #000 !important;\n}\n\n.css-hl58tn-MuiInputBase-root-MuiFilledInput-root.Mui-focused {\n  width: 314px !important;\n}\n\n.containerQuestion .MuiInputBase-root {\n  padding: 35px 12px 8px !important;\n}\n\n.css-dfpqc0 {\n  position: absolute !important;\n}\n\n.hover-container {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.truncated {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 200px;\n  display: inline-block;\n}\n\n.hover-popup {\n  position: absolute;\n  top: 120%;\n  left: 0;\n  background: white;\n  color: black;\n  padding: 8px 12px;\n  border-radius: 6px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  white-space: nowrap;\n  z-index: 999;\n  display: none;\n}\n\n.hover-container:hover .hover-popup {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
